import { QueryKeysConfig } from "@/config/query-keys";
import { createFileRoute } from "@tanstack/react-router";
import PostsFeed from "@/components/PostsFeed";
import { usePostsByTagLoader } from "@/hooks/network/use-posts-by-tag-loader";
export const Route = createFileRoute("/tag/$slug")({
  component: PostsByTag,
  shouldReload() {
    return false;
  },
  async loader(ctx) {
    const load = () => Promise.resolve();
    await load();
  },
  head(ctx) {
    const title = `Поиск по метке ${ctx.params.slug}`;
    return {
      meta: [{
        title
      }, {
        name: "og:title",
        content: title
      }]
    };
  }
});
function PostsByTag() {
  const {
    slug
  } = Route.useParams();
  const searchPosts = usePostsByTagLoader();
  const queryKey = [QueryKeysConfig.postsByTag, slug];
  const loader = ({
    pageParam
  }: any) => {
    return searchPosts({
      data: {
        after: pageParam,
        tag: slug
      }
    });
  };
  return <PostsFeed queryKey={queryKey} loader={loader} />;
}